import { useMainContext } from "../../context";
import { ItemPageProvider } from "./context";
import { useMemo } from "react";
import SelectRequirementsComponent from "./components/selectRequirementsComponent";
import SelectAditionalComponent from "./components/selectAditionalComponent";
import OrderSummary from "./components/orderSummary";
import ObsComponent from "./components/obsComponent";
import ImageLoader from "../../components/imageLoader";
import maskMoney from "../../utils/maskMoney";

const ItemPage = ({ location }) => {
  const { product } = useMainContext();

  const title = useMemo(() => {
    if (!product) {
      return "Carregando...";
    }

    let title = product.name;

    if (!product?.category?.has_one_size) {
      title += ` - ${product.size.name}`;
    }

    return title;
  }, [product]);

  if (product) {
    return (
      <ItemPageProvider>
        <div className="p-4 md:p-8 space-y-6">
          <div className="md:aspect-video w-full h-64 md:h-96 rounded-lg overflow-hidden mb-4 md:mb-8">
            <ImageLoader
              alt={product.name}
              src={
                product.photo
                  ? `${process.env.REACT_APP_SERVER_BETABIT_BASE_API}/files/products/${product.photo}`
                  : undefined
              }
            />
          </div>

          <section className="space-y-3">
            <div className="flex flex-col md:flex-row items-start justify-between gap-2">
              <h1 className="font-bold text-3xl">{title}</h1>

              <span className="text-3xl font-medium text-primary-500">
                {maskMoney(product.price)}
              </span>
            </div>

            {product.description && (
              <p className="text-md">{product.description}</p>
            )}
          </section>

          <SelectRequirementsComponent />

          <SelectAditionalComponent />

          <ObsComponent />

          <div className="h-1 bg-gray-300"></div>

          <OrderSummary />
        </div>
      </ItemPageProvider>
    );
  } else {
    return (
      <div>
        <div className="p-4 md:p-8 space-y-6">
          <div className="md:aspect-video w-full h-64 md:h-96 rounded-lg overflow-hidden mb-4 md:mb-8 bg-gray-200 animate-pulse" />

          <section className="space-y-3">
            <div className="flex flex-col md:flex-row items-start justify-between gap-2">
              <div className="font-bold text-3xl bg-gray-200 animate-pulse w-48 h-10 rounded" />

              <div className="text-3xl font-medium text-primary-500 bg-gray-200 animate-pulse w-24 h-10 rounded" />
            </div>

            <div className="space-y-2">
              <div className="text-md bg-gray-200 animate-pulse w-full h-4 rounded" />
              <div className="text-md bg-gray-200 animate-pulse w-full h-4 rounded" />
              <div className="text-md bg-gray-200 animate-pulse w-3/4 h-4 rounded" />
            </div>
          </section>
        </div>
      </div>
    );
  }
};

export default ItemPage;
